module.exports = __webpack_public_path__ + "static/media/logo-white.754c5ee7.svg";